import styled from 'styled-components';
import InputBase from 'components/InputBase';
import { TextFieldStyleProps } from './types';

export const Root = styled.div<TextFieldStyleProps>`
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  width: ${(props) => (props.fluid ? '100%' : 'auto')};
`;

export const InputContainer = styled(InputBase)`
  cursor: text;
`;
